import React, { PureComponent } from 'react';
import { createContainer } from '@dbk-legacy/muster/react';
import PropTypes from 'prop-types';
import {
  View,
  TouchableOpacity,
  Animated,
  Easing,
  Platform,
} from 'react-native';
import { CrossIcon, WarningIcon, ErrorIcon } from '../../../components/common/icons';
import Text from '@dbk/ui-text';
import styles from './dismissable-bar.styles';
import { PALETTE } from '../../../constants';
import { Toast } from '@dbk/ui-notifications'


class DismissableBar extends PureComponent {
  state = { dismissed: false }

  dismiss = (error, key) => this.props.deleteRecord(error, key);

  render() {
    const { dismissed } = this.state;
    const {
      error: { errorType, errorDesc , sevType},
      error,
      keyValue,
      i18n: {messages}
    } = this.props;

    if(sevType === "Ignore") return null;
    const errorTypeText = (errorType === 'Error') ? messages['app.payments.confirmation.error'] : messages['app.warning.text'];
    return (

      <div className="error-container" >
        <Toast underline status={errorType === "Error" ? "error" : "information"} 
        onClose={(e) => this.dismiss(error, keyValue)} >
          <div className='toast-header'>
            <Text  aria-label={errorTypeText} role="alert" tabIndex="0">{errorTypeText}</Text>
          </div>
          <div className='toast-content'>
            <Text  aria-label={errorDesc} role="alert" tabIndex="0">{errorDesc}</Text>
          </div>
        </Toast>
      </div>
    );
  }
}

DismissableBar.propTypes = {
  dismissed: PropTypes.bool,
  setDismissed: PropTypes.func,
  errorType: PropTypes.string,
};

DismissableBar.defaultProps = {
  dismissed: false,
  errorType: "Error"
};

export default createContainer({
  $queries: {
    i18n: {
      messages: true,
    }
  }
})(DismissableBar)
